import AircraftGallery from './AircraftGallery';
export default AircraftGallery;
